const charset = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
const base = BigInt(62);
const uuidHexLength = 32;
const uuidBase62Length = 22;
const maxUuidValue = (BigInt(1) << BigInt(128)) - BigInt(1);
const base62Lookup = Object.fromEntries(charset.map((char, index) => [char, index]));

export const base62Encode = (bigint: bigint): string => {
    if (bigint === BigInt(0)) {
        return '0';
    }

    let num = bigint;
    let str: string[] = [];

    while (num > 0) {
        str = [charset?.[Number(num % base)] ?? '', ...str];
        num = num / base;
    }

    return str.join('');
};

export const base62Decode = (str: string): bigint => {
    let result = BigInt(0);

    for (const char of str) {
        const index = base62Lookup[char];

        if (index === undefined) {
            throw new Error(`Invalid base62 character: ${char}`);
        }

        result = result * base + BigInt(index);
    }

    return result;
};

export const uuidToBase62 = (uuid: string): string => {
    const hex = uuid.replace(/-/g, '');

    if (hex.length !== uuidHexLength) {
        throw new Error(`Invalid UUID format: ${uuid}`);
    }

    const num = BigInt(`0x${hex}`);
    return base62Encode(num).padStart(uuidBase62Length, '0');
};

export const base62ToUuid = (base62: string): string => {
    const num = base62Decode(base62);

    if (num > maxUuidValue) {
        throw new Error(`Invalid base62 UUID: value exceeds 128 bits`);
    }

    const hex = num.toString(16).padStart(uuidHexLength, '0');

    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20, 32)}`;
};
